// extracted by mini-css-extract-plugin
export var discard = "_5o-3";
export var muiTooltipTooltip = "_5o-5";
export var notificationBar = "_5o-2";
export var saveButtonHoverSlotWrapper = "_5o-4";
export var show = "_5o-1";
export var spacer = "_5o-0";